import HttpError from "../http_error";
import weatherRoutingAxiosInstance from "../weather_routing_axios_instance";

export default class WeatherRoutingVoyageSolutionsService {
  constructor(baseUrl, voyageSolutionDataFromJsonMapper, computationDataFromJsonMapper,
    vesselPositionDataMapperToJson, voyageMeshDataFromJsonMapper) {
    this.baseUrl = baseUrl;
    this.voyageSolutionDataFromJsonMapper = voyageSolutionDataFromJsonMapper;
    this.computationDataFromJsonMapper = computationDataFromJsonMapper;
    this.vesselPositionDataMapperToJson = vesselPositionDataMapperToJson;
    this.voyageMeshDataFromJsonMapper = voyageMeshDataFromJsonMapper;
  }

  async getVoyageSolutions(accessToken, theyrAccessToken, id, computationId) {
    const params = {
      "speed": true,
      "direction": true,
      "speedUnit": "kn",
      "distanceUnit": "km",
      "directionUnit": "degree",
      "operational": true,
      "computation": computationId,
    };
    try {
      const response = await weatherRoutingAxiosInstance.get(
        `${this.baseUrl}/voyage_solutions/${id}`,
        {
          accept: "application/json",
          headers: {
            "access-token": `${accessToken}`,
            "theyr-token": `${theyrAccessToken}`
          },
          params: params,
        }
      );
      return this.voyageSolutionDataFromJsonMapper(response.data);
    } catch (error) {
      throw new HttpError(error.response.data.detail, error.response.status);
    }
  }

  async getVoyageSolutionsMesh(accessToken, theyrAccessToken, id, computationId) {
    try {
      const response = await weatherRoutingAxiosInstance.get(
        `${this.baseUrl}/voyage_solutions/${id}/mesh`,
        {
          accept: "application/json",
          headers: {
            "access-token": `${accessToken}`,
            "theyr-token": `${theyrAccessToken}`
          },
          params: {
            "computation": computationId
          }
        }
      );
      return this.voyageMeshDataFromJsonMapper(response.data);
    } catch (error) {
      throw new HttpError(error.response.data.detail, error.response.status);
    }
  }

  async getVoyageComputations(accessToken, theyrAccessToken, voyage_id) {
    try {
      const response = await weatherRoutingAxiosInstance.get(
        `${this.baseUrl}/v2/computation/${voyage_id}`,
        {
          accept: "application/json",
          headers: {
            "access-token": `${accessToken}`,
            "theyr-token": `${theyrAccessToken}`
          },
        }
      );
      const computations = response.data.map((datum) => this.computationDataFromJsonMapper(datum));
      return computations;
    } catch (error) {
      throw new HttpError(error.response.data.detail, error.response.status);
    }
  }

  async updateVesselPosition(accessToken, theyrAccessToken, id, vesselPositionData) {

    const params = this.vesselPositionDataMapperToJson(vesselPositionData);
    try {
      await weatherRoutingAxiosInstance.get(
        `${this.baseUrl}/update_vessel_position/${id}`,
        {
          accept: "application/json",
          headers: {
            "access-token": `${accessToken}`,
            "theyr-token": `${theyrAccessToken}`
          },
          params: params,
        }
      );
    } catch (error) {
      if (error.response.status === 428) {
        const errorMessage =
        "The selected coordinates are outside the calculation area. Select different starting coordinates for the recalculation.";
        throw new HttpError(errorMessage, error.response.status);
      }
      else {
        throw new HttpError(error.response.data.detail, error.response.status);
      }
    }
  }

}
